import * as React from 'react';

import * as styles from './FormCardFooterLayout.css';

export const FormCardFooterLayout = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
  return <div className={styles['footer']}>{children}</div>;
};
